import template from './HeadCell.html';

export default {
	template,
	data() {
		return {
			parentY: 0,
			height: 40,
			offset: 0
		};
	},
	props: ['sort', 'sortRev', 'noSticky', 'noCssSticky', 'filter-key'],
	computed: {
		style() {
			let css = {};
			let offset = !this.offset ? 0 : (this.offset - 1);
			css.borderBottomWidth = offset ? '1px' : 0;
			css.transform = 'translateY(' + offset + 'px)';
			return css;
		},
		arrowIcon() {
			let qSort = this.app.query.sort;
			if (!qSort) return;
			
			if (qSort === this.sort) return 'up';
			if (qSort.startsWith('-') && qSort.slice(1) === this.sort) return 'down';
		}
	},
	methods: {
		tryRecalc() {
			let scrollY = this.win.scrollTop;
			let diff = scrollY - this.parentY + this.height - 1;
			this.offset = Math.max(diff, 0);
		},
		updateParentY() {
			if (this.noCssSticky) {
				this.$el.parentNode.style.position = 'sticky';
				this.$el.parentNode.style.top = (this.height - 2) + 'px';
				this.$el.parentNode.style.zIndex = 9;
				this.offset = 0;
				
				return;
			}
			
			this.$el.parentNode.style.position = 'relative';
			this.$el.parentNode.style.top = '0px';
			
			let newParentY = this.$el.parentNode.getBoundingClientRect().top + this.win.scrollTop;
			if (newParentY !== this.parentY) {
				this.parentY = newParentY;
				this.tryRecalc();
			}
		},
		onScroll() {
			if (this.noCssSticky) return;
			
			this.tryRecalc();
		},
		sortTable(sort, isReverse = false) {
			let query;
			let querySort = this.app.query.sort;
			if (querySort && querySort.startsWith('-')) {
				querySort = querySort.substr(1);
			}
			if (sort === querySort) {
				if (!this.app.query.sort.startsWith('-')) {
					sort = '-' + sort;
				}
			} else {
				sort = isReverse ? sort : '-' + sort;
			}
			if (!sort) {
				sort = undefined;
			}
			query = {...this.app.query, sort};
			
			this.$router.push({query});
		}
	},
	mounted() {
		if (this.noSticky) return;
		
		this.updateParentY();
		setInterval(_ => this.updateParentY(), 2000);
		
		window.addEventListener('scroll', this.onScroll);
		window.addEventListener('resize', this.updateParentY);
	},
	destroyed() {
		if (this.noSticky) return;
		
		window.removeEventListener('scroll', this.onScroll);
		window.removeEventListener('resize', this.updateParentY);
	}
};